import { QuoteSettingsForm } from "#modules/company/view/QuoteSettingsForm";
import { useCompany } from "#modules/company/view/useCompany";
import { PageLayout } from "#shared/layouts/PageLayout";
import { Alert } from "#shared/view/components/Alert";
import { Loader } from "#shared/view/components/Loader";

export const QuotingSettingsPage = () => {
  const { company, isLoading } = useCompany();

  if (isLoading) {
    return <Loader />;
  }

  if (!company) {
    return (
      <Alert color="red" title="Un problème est survenu">
        Un problème est survenu à la récupération des informations de l'entreprise
      </Alert>
    );
  }

  return (
    <PageLayout
      title="Configuration chiffrage"
      subtitle="Configurez vos taux horaires, les taux de marges, vos consommables et la matière première utilisée."
      withBorder
      fullWidth
    >
      <QuoteSettingsForm company={company} />
    </PageLayout>
  );
};
